module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/780da7015fb50f3e8b91b27b61fd95c7.gif";